<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'star'
};
</script>

<style lang="less" scoped></style>
